import { Avatar } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import Table from 'components/Table';
import { MobileTableType } from 'components/Table/types';
import useReactiveQueryTable from 'hooks/useReactiveQueryTable';
import React from 'react';
import { useHistory } from 'react-router';
import ROUTES from 'routes/routeConstants';
import { GET_NOTARY_USERS_BY_INVOICE } from 'services/graphql/queries/user.query';
import { IUser, RoleEnum } from 'types/user';
import { getDefaultAvatarUrl, getLink } from 'utils';

import { ISummaryTableProps } from '../types';

interface IUserColumnProps {
  name: string;
  avatar: string;
  email: string;
}

const NotarySummaryTable: React.FC<ISummaryTableProps> = ({ active }) => {
  const history = useHistory();
  const notarySummaryColumns: ColumnsType<any> = [
    {
      title: 'Notary',
      dataIndex: 'name',
      render: (user: IUserColumnProps) => (
        <div>
          <div className='gx-d-flex gx-align-items-center'>
            <Avatar style={{ minWidth: 32 }} src={user.avatar} className='gx-mr-2' />
            <div>
              <div style={{ flex: '1' }} className='gx-font-weight-medium'>
                {user.name}
              </div>
              <div className='break-all' style={{ color: '#8C8C8C' }}>
                {user.email}
              </div>
            </div>
          </div>
        </div>
      ),
      width: '40%',
      sorter: true,
    },
    {
      title: 'Appointments',
      dataIndex: 'appointmentCount',
      render: (appointments: number) => <div>{appointments || 0}</div>,
      width: '30%',
      sorter: true,
    },
    {
      title: 'Earned',
      dataIndex: 'total',
      render: (total: number) => <div style={{ color: '#038FDE' }}> ${total || 0}</div>,
      sorter: true,
    },
    {
      title: 'Paid',
      dataIndex: 'paid',
      render: (paid: number) => <div style={{ color: '#038FDE' }}>${paid || 0}</div>,
      sorter: true,
    },
  ];

  const dataMapper = (user: IUser) => ({
    key: user.id,
    ...user,
    name: {
      name: `${user.firstName} ${user.lastName}`,
      avatar: user.avatar || getDefaultAvatarUrl(user.firstName ? `${user.firstName} ${user.lastName}` : ''),
      email: user.email,
    },
    appointmentCount: user?.appointmentCount || 0,
    total: user?.total || 0,
    paid: user?.paid || 0,
    userData: user,
  });

  const tableProps = useReactiveQueryTable({
    graphQLQuery: GET_NOTARY_USERS_BY_INVOICE,
    columns: notarySummaryColumns,
    dataMapper,
    mapQueryToVariables: () => ({
      role: RoleEnum.NOTARY,
    }),
    queryProps: {
      skip: !active,
      fetchPolicy: 'cache-and-network',
    },
  });

  return (
    <Table
      {...tableProps}
      mobileDesignType={MobileTableType.RESPONSIVE_TABLE}
      responsiveFullBordered
      widthThreshold={597}
      onRow={(record: any) => ({
        onClick: () => {
          history.push(getLink(ROUTES.ACCOUNTING_DETAIL, { type: 'notary', id: record.key }));
        },
      })}
    />
  );
};

export default React.memo(NotarySummaryTable);
